import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { useAuthContext } from '@providers/AuthProvider';

import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const ASOneSubscriptionDetails = () => {
  const { orgSlug, aOneId } = useParams<{ orgSlug: string; aOneId: string }>();
  const { organization } = useAuthContext();

  if (!organization || !organization.billingAccount || organization.slug !== orgSlug) {
    return <></>;
  }

  return (
    <PageProvider orgSlug={orgSlug} aOneId={aOneId}>
      <Helmet>
        <title>AutoScriptOne Subscription Details - AutoScript</title>
      </Helmet>
      <Content />
    </PageProvider>
  );
};
